<template>
  <div>
    <!-- 批量导入 -->
    <el-dialog
      width="500px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      v-if="importVisible"
      :visible.sync="importVisible"
      title="导入"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :rules="addFormRules"
        label-width="100px"
      >
        <el-form-item label="数据导入：" prop="file">
          <el-upload
            ref="uploadEl"
            class="upload-demo"
            action
            :auto-upload="false"
            accept=".xls,.xlsx"
            :on-change="onFileChange"
            :http-request="upload"
            :file-list="fileList"
          >
            <el-button size="small" type="success">选择EXCEL</el-button>
            <!-- <span class="upload-tip">(包含批次号、产品编号列即可)</span> -->
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importVisible = false">取消</el-button>
        <el-button type="success" @click="confirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      importVisible: false,
      addForm: {
        file: "",
      },
      addFormRules: {
        file: [
          { required: true, message: "导入文件不能为空", trigger: "blur" },
        ],
      },
      fileList: [],
      fullLoading: null,
    }
  },
  methods: {
    importProduct() {
      this.addForm.file = "";
      this.fileList = [];
      this.importVisible = true;
    },
    confirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;

        this.$refs.uploadEl.submit();
      });
    },
    onFileChange(file) {
      if (file) {
        this.addForm.file = file.name;
        this.fileList = [file];
      }
    },
    upload({ file }) {
      this.showLoading();
      let taskDTO = {
        reportName: 'reviewProductImport',
        appCode: "soft-vote-web",
        paramMap: []
      };
      let formData = new FormData();
      formData.append('file', file);
      formData.append('taskDTO', JSON.stringify(taskDTO))
      this.$q.excelConfig.import(formData)
        .then(({ code, message, data }) => {
          const isSuccess = code === 200;
          this.showResult(isSuccess, message);

          if (isSuccess) {
            this.importVisible = false;
            this.$emit('onsuccess', null);
          }
        })
        .finally(() => {
          this.closeLoading();
        });
    },
    showResult(isSuccess = true, message) {
      if (isSuccess) {
        this.$notify.success({
          title: "成功",
          message: `评审产品导入成功！`,
        });
      } else {
        this.$notify.error({
          title: "错误",
          message,
        });
      }
    },
    showLoading() {
      this.closeLoading();

      this.fullLoading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
      });
    },
    closeLoading() {
      if (this.fullLoading) {
        this.fullLoading.close();
      }
    }
  }
}
</script>

<style>

</style>